/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  Panel,
} from 'react-bootstrap';
import RichButton from 'loracoms/RichButton';
import ControlTips from 'loracoms/ControlTips';
import FormBlock from 'loracoms/FormBlock';
import accountActions from 'loraactions/account';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import styles from './styles.scss';


const propTypes = {
  intl: React.PropTypes.any.isRequired,
  changed: React.PropTypes.object.isRequired,
  changePassword: React.PropTypes.func.isRequired,
};

class SecurityView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      errors: (
        new ErrorSet()
          .add('FE_EMPTY', 'oldpwd')
          .add('FE_EMPTY', 'newpwd')
          .add('FE_EMPTY', 'newpwd2')
      ),
      changeSubmitted: false,
    };
    this.intlMsg = new IntlMsg(props.intl, 'accountcenter.securityview');
    this.handleSubmitPassword = this.handleSubmitPassword.bind(this);
    this.handleChangeOldPassword = this.handleChangeOldPassword.bind(this);
    this.handleChangeNewPassword = this.handleChangeNewPassword.bind(this);
    this.handleChangeNewPassword2 = this.handleChangeNewPassword2.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { changed } = nextProps;

    if (changed !== this.props.changed) {
      this.setState({ changedStatus: changed.status });
      if (changed.status === 'success') {
        this.setState({
          oldPassword: '',
          newPassword: '',
          newPassword2: '',
          changeSubmitted: false,
          errors: (
            new ErrorSet()
              .add('FE_EMPTY', 'oldpwd')
              .add('FE_EMPTY', 'newpwd')
              .add('FE_EMPTY', 'newpwd2')
          ),
        });
      }
      if (changed.status === 'failure') {
        const { errors } = this.state;
        this.setState({
          errors: errors.add(changed.error.code, 'submit'),
        });
        const that = this;
        if (this.timeout) {
          clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(() => {
          that.setState({ errors: errors.remove('submit') });
        }, 3000);
      }
    }
  }

  componentWillUnmount() {
    if (this.timout) {
      clearTimeout(this.timeout);
    }
  }

  handleSubmitPassword(e) {
    e.preventDefault();

    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.setState({
      changeSubmitted: true,
    });

    const {
      oldPassword = '',
      newPassword = '',
      newPassword2 = '',
    } = this.state;

    let errors = new ErrorSet();

    if (oldPassword === '') {
      errors = errors.add('FE_EMPTY', 'oldpwd');
    }
    if (newPassword === '') {
      errors = errors.add('FE_EMPTY', 'newpwd');
    }
    if (newPassword2 === '') {
      errors = errors.add('FE_EMPTY', 'newpwd2');
    }
    if (newPassword !== newPassword2) {
      errors = (
        errors
          .add('FE_NOTSAME', 'newpwd2')
          .add('FE_NOTSAME', 'newpwd')
      );
    }
    if (newPassword.length < 6) {
      errors = errors.add('FE_TOOSHORT', 'newpwd');
    }
    if (oldPassword === newPassword) {
      errors = errors.add('FE_NOTCHANGED', 'newpwd');
    }

    this.setState({ errors });

    if (!errors.isEmpty()) {
      return;
    }

    const { changePassword } = this.props;
    changePassword(oldPassword, newPassword);
  }

  handleChangeOldPassword(e) {
    const { errors } = this.state;

    const oldPassword = e.target.value.trim();
    this.setState({ oldPassword });
    if (oldPassword === '') {
      this.setState({
        errors: errors.add('FE_EMPTY', 'oldpwd'),
      });
    } else {
      this.setState({
        errors: errors.remove('oldpwd'),
      });
    }
  }

  handleChangeNewPassword(e) {
    const { errors } = this.state;

    const newPassword = e.target.value.trim();
    this.setState({ newPassword });
    if (newPassword === '') {
      this.setState({
        errors: errors.remove('newpwd2').add('FE_EMPTY', 'newpwd'),
      });
    } else {
      this.setState({
        errors: errors.remove('newpwd').remove('newpwd2'),
      });
    }
  }

  handleChangeNewPassword2(e) {
    const { errors } = this.state;

    const newPassword2 = e.target.value.trim();
    this.setState({ newPassword2 });
    if (newPassword2 === '') {
      this.setState({
        errors: errors.remove('newpwd').add('FE_EMPTY', 'newpwd2'),
      });
    } else {
      this.setState({
        errors: errors.remove('newpwd').remove('newpwd2'),
      });
    }
  }

  renderChangePassword() {
    const {
      oldPassword = '',
      newPassword = '',
      newPassword2 = '',
      errors,
      changeSubmitted = false,
      changedStatus = '',
    } = this.state;

    return (
      <Panel
        bsStyle="aisz-white"
        header={this.intlMsg.msg('changepwd.title')}
        className={styles.chpwd}
      >
        <Form onSubmit={this.handleSubmitPassword}>
          <FormGroup>
            <ControlLabel className="aisz-control-label">
              {this.intlMsg.msg('changepwd.oldpwd')}
            </ControlLabel>
            <FormControl
              bsClass="aisz-form-control-f"
              type="password"
              value={oldPassword}
              onChange={this.handleChangeOldPassword}
            />
            <ControlTips
              show={errors.has('oldpwd') && changeSubmitted}
              message={this.intlMsg.errorMsg(errors.get('oldpwd'))}
              azStyle="danger"
            />
          </FormGroup>
          <FormGroup>
            <ControlLabel className="aisz-control-label">
              {this.intlMsg.msg('changepwd.newpwd')}
            </ControlLabel>
            <FormControl
              bsClass="aisz-form-control-f"
              type="password"
              value={newPassword}
              onChange={this.handleChangeNewPassword}
            />
            <ControlTips
              show={errors.has('newpwd') && changeSubmitted}
              message={this.intlMsg.errorMsg(errors.get('newpwd'))}
              azStyle="danger"
            />
          </FormGroup>
          <FormGroup>
            <ControlLabel className="aisz-control-label">
              {this.intlMsg.msg('changepwd.newpwd.repeat')}
            </ControlLabel>
            <FormControl
              bsClass="aisz-form-control-f"
              type="password"
              value={newPassword2}
              onChange={this.handleChangeNewPassword2}
            />
            <ControlTips
              show={errors.has('newpwd2') && changeSubmitted}
              message={this.intlMsg.errorMsg(errors.get('newpwd2'))}
              azStyle="danger"
            />
          </FormGroup>
          <FormGroup>
            <div className={styles.submit}>
              <RichButton
                status={changedStatus}
                states={[{
                  status: 'default',
                  label: (
                    <span>
                      {this.intlMsg.msg('changepwd.submit')}{' '}
                      <span className="halflings halflings-ok" />
                    </span>
                  ),
                  type: 'submit',
                }, {
                  status: 'success',
                  label: this.intlMsg.msg('changepwd.success'),
                  style: 'success',
                  timer: () => this.setState({ changedStatus: '' }),
                }, {
                  status: 'failure',
                  label: this.intlMsg.msg('changepwd.failure'),
                  style: 'danger',
                  timer: () => this.setState({ changedStatus: '' }),
                }]}
              />
            </div>
            <FormBlock
              show={errors.has('submit')}
              message={this.intlMsg.errorMsg(errors.get('submit'))}
              azStyle="danger"
            />
          </FormGroup>
        </Form>
      </Panel>
    );
  }

  render() {
    return (
      <div className={styles.content}>
        {this.renderChangePassword()}
      </div>
    );
  }
}

SecurityView.propTypes = propTypes;

const mapStateToProps = state => ({
  changed: state.account.changePassword,
});

const mapDispatchToProps = {
  changePassword: accountActions.changePassword,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(SecurityView));




// WEBPACK FOOTER //
// ./src/containers/AccountCenter/coms/SecurityView/index.jsx